// @core/api/endpoints/chat/update_presence.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdatePresenceRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Update presence status
 * Updates the current user's online presence status and optional status message. Status is broadcast to other users in shared conversations.
 */
export async function UpdatePresence(
  data: UpdatePresenceRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/presence`;
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
